import { AuthLayout } from "../AuthLayout"
import { SignUpForm } from "../SignUpForm"

export function SignUpPage() {
  return (
    <AuthLayout
      tagline={<>Plan <span className="text-primary">beautiful</span> trips,<br />make unforgettable memories.</>}
      subtagline="AI-powered recommendations just for you."
    >
      <SignUpForm />
    </AuthLayout>
  )
}
